export enum StatsFormatType {
	OVERALL = 'Overall',
	DOUBLES = 'Doubles',
	MIXED = 'Mixed',
	SINGLES = 'Singles',
	SKINNY_SINGLES = 'Skinny Singles'
}

export interface Stats {
	formatType: StatsFormatType;
	uuid: string;
	userUuid: string;
	matchWins: number;
	matchLosses: number;
	matchDiff: number;
	matchWinsPct: number;
	matchWinsPctChange: number;
	gameWins: number;
	gameLosses: number;
	gameDiff: number;
	gameWinsPct: number;
	gameWinsPctChange: number;
	pointsEarned: number;
	pointsAgainst: number;
	pointsDiff: number;
	pointsDiffPct: number;
	pointsEarnedPct: number;
	pointsEarnedPctChange: number;
	tbPointsEarned: number;
	tbPointsAgainst: number;
	tbPointsDiff: number;
	tbPointsDiffPct: number;
	tbPointsEarnedPctChange: number;
	avgPartnerRating: number;
	avgOpponentRating: number;
}
